import React from "react"
import { Card, CardBody, CardTitle, Table } from "reactstrap"

import { useWallet } from "../libs/useMetaMaskWallet"
import { useToast } from "../hooks/toast"
import { formatAddress, blockchainExplorers } from "../utils"
import { lootBoxType } from "./NFTSale/utils"
import subdomains from "../constants/subdomains.json"
import LootBoxCard from "../Components/LootBoxCard/LootBoxCard"
import CustomTooltip from "../Components/Tooltip"
import BreadCrumb from "../Components/BreadCrumb"

const LootboxDetail = (props) => {
    const {
        lootbox,
        subdomain,
        idx,
        allowance,
        balance,
        enableClickLootbox,
        lootBoxIsPurchased = false,
        collectionAddress,
        chain,
        contractOwner,
        collectionSymbol
    } = props?.location?.state || {}

    const lootboxDetailsHeaderText = subdomains[subdomain]?.lootboxDetailsHeaderText
    const lootboxDetailsTxt1 = subdomains[subdomain]?.lootboxDetails?.[lootBoxType[lootbox?.name] || lootbox?.type]

    const wallet = useWallet()
    const toast = useToast()

    // console.log("collectionAddress, chain, contractOwner, collectionSymbol", collectionAddress, chain, contractOwner, collectionSymbol)
    // console.log("Lootbox", lootbox)

    const handleCopyClick = (text) => {
        navigator.clipboard.writeText(text.replace("×", "x"))
        toast.addSuccess(`${formatAddress(text)} copied to clipboard.`)
    }

    const renderTableAttributes = (attributes) => {
        // attributes === stringified array of objects. [{"trait_type": "color", "value": "blue"}, {"trait_type": "location", "value": "italy"}]
        if (attributes === undefined) return null
        // attributes = JSON.parse(attributes)
        return (
            <div className="attributes-inner">
                {attributes?.map((attribute, idx) => {
                    return (
                        <div key={idx}>
                            {attribute.trait_type} : {attribute.value}
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <div className="content lootbox-detail-wrap">
            <BreadCrumb items={["NFT Sale", "Loot Box Details"]} links={["nftsale"]} />

            <Card className="nft-sale-welcome">
                <CardBody>
                    <CardTitle className="h3">{lootboxDetailsHeaderText + ": " + lootbox?.name}</CardTitle>

                    <div className="lootbox-txt-1">{lootboxDetailsTxt1}</div>

                    <div className={"left-right-wrap" + (lootbox?.opened ? " box-open" : "")}>
                        <div className="lootbox-detail-left">
                            <div className="nft-sale-card-wrap">
                                <LootBoxCard
                                    lootbox={lootbox}
                                    idx={idx}
                                    subdomain={subdomain}
                                    allowance={allowance}
                                    balance={balance}
                                    enableClickLootbox={enableClickLootbox}
                                    lootBoxIsPurchased={lootBoxIsPurchased}
                                    contractType="boxCollection"
                                />
                            </div>
                        </div>

                        <div className="lootbox-detail-right">
                            <ul>
                                <li>
                                    <span className="detail-label">Contract Address</span>
                                    <span className="detail-val">
                                        {/* {formatAddress(collectionAddress)} */}
                                        {collectionAddress}
                                        <CustomTooltip title="Open in blockchain explorer" placement="bottom">
                                            <i
                                                className="bx bx-link-external"
                                                onClick={() => {
                                                    // open blockchain explorer in new tab
                                                    const url = `${blockchainExplorers[chain.toLowerCase()]}${collectionAddress}`
                                                    window.open(url, "_blank", "noopener,noreferrer")
                                                }}
                                            />
                                        </CustomTooltip>
                                    </span>
                                </li>
                                {lootBoxIsPurchased && (
                                    <li>
                                        <span className="detail-label">Contract Owner</span>
                                        <span className="detail-val">
                                            {contractOwner}
                                            <CustomTooltip title="Copy Address" placement="bottom">
                                                <i className="bx bx-copy" onClick={() => handleCopyClick(contractOwner)} />
                                            </CustomTooltip>
                                        </span>
                                    </li>
                                )}
                                <li>
                                    <span className="detail-label">Blockchain</span> <span className="detail-val">{chain}</span>
                                </li>
                                <li>
                                    <span className="detail-label">Collection Symbol</span> <span className="detail-val">{collectionSymbol}</span>
                                </li>
                                {lootBoxIsPurchased && (
                                    <React.Fragment>
                                        <li>
                                            {/* TO DO: call method on contract to get current owner- hard coded to users wallet address for now */}
                                            <span className="detail-label">Token Owner</span>
                                            <span className="detail-val">
                                                {wallet?.account}
                                                <CustomTooltip title="Copy Address" placement="bottom">
                                                    <i className="bx bx-copy" onClick={() => handleCopyClick(wallet?.account)} />
                                                </CustomTooltip>
                                            </span>
                                        </li>

                                        <li>
                                            <span className="detail-label">Token ID</span> <span className="detail-val">{lootbox?.boxId}</span>
                                        </li>
                                        <li>
                                            <span className="detail-label">Metadata URI </span>
                                            <span className="detail-val metadata-uri">
                                                <a href={lootbox?.tokenURI} target="_blank">
                                                    {lootbox?.tokenURI}
                                                </a>
                                            </span>
                                        </li>
                                    </React.Fragment>
                                )}
                            </ul>

                            {/* DIABLED- currently cant determine which token are linked to which lootbox token they were opened */}
                            {/* {lootbox?.opened && (
                                <React.Fragment>
                                    <div className="overflow-auto">
                                        <Table className="lootbox-nfts-table align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="nft-name">
                                                        Name
                                                    </th>
                                                    <th scope="col" className="nft-description">
                                                        Description
                                                    </th>
                                                    <th scope="col">Image</th>
                                                    <th scope="col" className="nft-attributes">
                                                        Attributes
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {userNFTs?.map((nft, idx) => {
                                                    return (
                                                        <tr key={idx} className={"nft-row"} onClick={(e) => setNft(nft)}>
                                                            <td className="name">
                                                                <span className="name-val">{nft?.name}</span>
                                                                <div className="mobile-ui-description">{nft?.description}</div>
                                                            </td>
                                                            <td className="description-row">{nft?.description}</td>
                                                            <td className="image">
                                                                <img alt="imgdata" src={nft?.imgUrl} className="lootbox-nft-img" />
                                                            </td>
                                                            <td className="attributes">{renderTableAttributes(nft?.attributes)}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>

                                    {nft && (
                                        <LootBoxNFTModal showLootBoxNFTModal={!!nft} closeModal={() => setNft(null)} modalTitle={nft?.name}>
                                            <div className="description">{nft?.description}</div>
                                            <img alt="lootbox nft" src={nft?.imgUrl} />

                                            <div className="lootbox-nft-modal-info">
                                                <span className="modal-label">Token ID:</span> {nft?.tokenId}
                                            </div>

                                            <div className="lootbox-nft-modal-info">
                                                <span className="modal-label token-uri">Token URI:</span>
                                                <a href={nft?.tokenURI} target="_blank" className="token-uri-val">
                                                    {nft?.tokenURI}
                                                </a>
                                            </div>
                                        </LootBoxNFTModal>
                                    )}
                                </React.Fragment>
                            )} */}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default LootboxDetail
